<template>
  <div class="wpdonation-box">
    <h2 class="wpdonation-title" v-if="strings">{{ strings.title }}</h2>

    <!-- Form Builder Fields (New) -->
    <FormBuilderFields 
      v-if="use_form_builder && form_builder_config"
      :is_logged_in="is_logged_in"
      :email="email"
      :strings="strings"
      :use_form_builder="use_form_builder"
      :form_builder_config="form_builder_config"
      :formFields="form_builder_config.fields || []"
      @update:formData="updateFormBuilderData"
      @validation-change="handleValidationChange"
    />

    <!-- Legacy Form Fields (Fallback) -->
    <div class="easy-donation-box" v-else>
      <div class="single-credit-cardd">
        <div class="wpcm-row wpmc-justify-content-center">
          <div class="wpcm-col-md-6">
            <div class="textfield">
              <input
                type="text"
                :placeholder="trans('first_name')"
                v-model="store.billing_fields.first_name"
                :disabled="store.loading"
                required
              />
            </div>
          </div>
          <div class="wpcm-col-md-6">
            <div class="textfield">
              <input
                type="text"
                :placeholder="trans('last_name')"
                v-model="store.billing_fields.last_name"
                :disabled="store.loading"
                required
              />
            </div>
          </div>
          <div class="wpcm-col-md-12">
            <div class="textfield">
              <input
                type="email"
                :placeholder="trans('email')"
                v-model="store.billing_fields.email"
                :readonly="is_logged_in && email"
                :disabled="store.loading"                
                required
              />
            </div>
          </div>
          <div class="wpcm-col-md-12">
            <div class="textfield">
              <input
                type="text"
                :placeholder="trans('address')"
                :disabled="store.loading"
                v-model="store.billing_fields.address"
              />
            </div>
          </div>
          <div v-if="show_company" class="wpcm-col-md-12">
            <div class="textfield">
              <input
                type="text"
                :placeholder="trans('company')"
                :disabled="store.loading"
                v-model="store.billing_fields.company"
              />
            </div>
          </div>
          <div v-if="show_country" class="wpcm-col-md-12">
            <div class="textfield">
              <el-select
                filterable
                :placeholder="trans('country')"
                :loading="select_loading"
                v-model="store.billing_fields.country"
              >
                <el-option
                  v-for="(name, key) in countries"
                  :key="key"
                  :label="name"
                  :value="key">
                </el-option>
              </el-select>
              
            </div>
          </div>
          <div v-if="show_county" class="wpcm-col-md-12">
            <div class="textfield">
              <input
                type="text"
                :placeholder="trans('county')"
                :disabled="store.loading"
                v-model="store.billing_fields.state"
              />
            </div>
          </div>
          <div v-if="show_city" class="wpcm-col-md-12">
            <div class="textfield">
              <input
                type="text"
                :placeholder="trans('city')"
                :disabled="store.loading"
                v-model="store.billing_fields.city"
              />
            </div>
          </div>
          <div v-if="show_phone_no" class="wpcm-col-md-12">
            <div class="textfield">
              <input
                type="text"
                :placeholder="trans('phone_no')"
                :disabled="store.loading"
                v-model="store.billing_fields.phone"
              />
            </div>
          </div>
          <div v-if="show_postal" class="wpcm-col-md-12">
            <div class="textfield">
              <input
                type="text"
                :placeholder="trans('postal_code')"
                :disabled="store.loading"
                v-model="store.billing_fields.zip"
              />
            </div>
          </div>
          <div v-if="show_tax" class="wpcm-col-md-12">
            <div class="textfield">
              <input
                type="text"
                :placeholder="trans('tax_code')"
                :disabled="store.loading"
                v-model="store.billing_fields.tax"
              />
            </div>
          </div>
          <div v-if="show_anonymous_donation" class="wpcm-col-md-12 wpcm-anonymous-field">
            <el-checkbox
              v-model="store.billing_fields.anonymous_donation"
              :disabled="store.loading"
            >
              {{ trans('anonymous_donation') }}
            </el-checkbox>
          </div>
        
     

        </div>
      </div>
    </div>
    <!-- End Legacy Form Fields -->

    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useDonationFormsStore } from '../store';
import FormBuilderFields from './FormBuilderFields.vue';

const store = useDonationFormsStore();
const props = defineProps([
  "is_logged_in", "email", 'show_country', 'show_county', 'show_city', 
  'show_postal', 'show_tax', 'show_phone_no', 'show_company', 
  'show_anonymous_donation', 'enable_test_card_information', "strings",
  'use_form_builder', 'form_builder_config'
]);
const countries = ref([]);
const select_loading = ref(false);
const country = ref('');

const lifeline_donation = globalThis.lifeline_donation;

const setValue = (key, val) => {  
  store[key] = val;
};
const setBillingValue = (key, val: Event) => {
  store.billing_fields[key] = (val.target as HTMLInputElement).value;
};
const trans = (key) => {
  if (props.strings) {
    return props.strings[key];
  }
};
const getCountries = () => {
  select_loading.value = true;

  const $ = jQuery;

  $.ajax({
    url: lifeline_donation.homeurl+ '/wp-json/webinane-commerce/v1/countries',
    success: res => {
      countries.value = res.countries
    },
    complete: res => {
      select_loading.value = false
    }
  })
};

// Form Builder Methods
const updateFormBuilderData = (formData) => {
  // Update store with form builder data
  Object.keys(formData).forEach(key => {
    if (store.billing_fields.hasOwnProperty(key)) {
      store.billing_fields[key] = formData[key];
    } else {
      // Add new fields to billing_fields
      store.billing_fields[key] = formData[key];
    }
  });
};

const handleValidationChange = (validationData) => {
  // Handle field validation changes
  console.log('Field validation:', validationData);
};

onMounted(() => {
  if (props.is_logged_in && props.email) {
      store.billing_fields.email = props.email;
    }
    getCountries();
})


</script>